var OperazioneType;
(function (OperazioneType) {
    OperazioneType[OperazioneType["SUCCESS"] = 0] = "SUCCESS";
    OperazioneType[OperazioneType["ERROR"] = 1] = "ERROR";
    OperazioneType[OperazioneType["WARNING"] = 2] = "WARNING";
    OperazioneType[OperazioneType["MASSIVA"] = 3] = "MASSIVA";
})(OperazioneType || (OperazioneType = {}));
const Types = OperazioneType;
const Timeout = {
    SHORT: 5000,
    LONG: 10000,
    SUCCESS: 5000,
    ERROR: 10000,
    WARNING: 5000,
    MASSIVA: 5000,
};
var StatoOperazioneEnum;
(function (StatoOperazioneEnum) {
    StatoOperazioneEnum[StatoOperazioneEnum["PENDING"] = 0] = "PENDING";
    StatoOperazioneEnum[StatoOperazioneEnum["COMPLETED"] = 1] = "COMPLETED";
})(StatoOperazioneEnum || (StatoOperazioneEnum = {}));
const StatoOperazione = StatoOperazioneEnum;
const MAX_TEXT_LENGTH = 77;
const PENDING_OPERATION = 'Elaborazione in corso...';
const COMPLETED_OPERATION = 'Elaborazione terminata';
function isOperazioneWithTextCollapsed(operazione) {
    return (operazione.message.length > MAX_TEXT_LENGTH
        || Array.isArray(operazione.message));
}

export { COMPLETED_OPERATION, MAX_TEXT_LENGTH, OperazioneType, PENDING_OPERATION, StatoOperazione, StatoOperazioneEnum, Timeout, Types, isOperazioneWithTextCollapsed };
